import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-modal" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "modal-text" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('AuthModal.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.t('AuthModal.text1')) + " ", 1),
      _createVNode(_component_router_link, {
        to: "/tos",
        class: "text-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('AuthModal.tos')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "modal-check",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)))
    }, [
      _createVNode(_component_CheckBox, {
        class: "check-box-wrap",
        modelValue: _ctx.accept,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accept) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: _ctx.t('AuthModal.confirm')
          }, null, 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_BaseButton, {
        class: _normalizeClass(["base-button-wrap b-16 primary", { disabled: !_ctx.accept }]),
        onClick: _ctx.auth
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('AuthModal.auth')), 1)
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ])
  ]))
}